export const HealthInsuranceDropdown = () => (
  <div className="absolute left-0mt-[10px] w-screen bg-white shadow-lg p-6 z-20">
    <div className="grid grid-cols-4 gap-6">
      <div className="col-span-1 border-r pr-6">
        <h3 className="font-bold text-lg mb-4">Hospitalization Cover</h3>
        <ul className="space-y-2">
          <li>
            <a href="/">Personal Accident Plus</a>
          </li>
          <li>
            <a href="/">Critical Illness Cover</a>
          </li>
          <li>
            <a href="/">Daily Hospital Cash</a>
          </li>
          <li>
            <a href="/">Riders</a>
          </li>
          <li>
            <a href="/">Group Insurance</a>
          </li>
        </ul>
      </div>
      <div className="col-span-1 border-r pr-6">
        <ul className="space-y-2">
          <li>
            <a href="/">ProHealth Prime</a>
          </li>
          <li>
            <a href="/">Lifetime Health</a>
          </li>
          <li>
            <a href="/">Prime Senior</a>
          </li>
          <li>
            <a href="/">ProHealth Insurance</a>
          </li>
          <li>
            <a href="/">ProHealth Select</a>
          </li>
          <li>
            <a href="/">Super Top Up</a>
          </li>
          <li>
            <a href="/">Arogya Sanjeevani Policy</a>
          </li>
        </ul>
      </div>
      <div className="col-span-2">
        <div className="flex justify-between items-start mb-4">
          <h3 className="font-bold text-xl text-blue-600">ProHealth Prime</h3>
          <div className="flex items-center">
            <div className="flex text-yellow-400 mr-2">
              Icon
              {/* <Star size={20} fill="currentColor" />
                            <Star size={20} fill="currentColor" />
                            <Star size={20} fill="currentColor" />
                            <Star size={20} fill="currentColor" />
                            <Star size={20} /> */}
            </div>
            <span className="text-sm">1000 reviews</span>
            <button className="ml-auto flex items-center text-blue-600">
              {/* <Download size={20} className="mr-2" /> */}
              Icons DOWNLOAD PRODUCT BROCHURE
            </button>
          </div>
        </div>
        <p className="mb-4">
          A comprehensive and flexible Health Insurance Plan that offers Better
          Coverage, Better Control and Better Care
        </p>
        <h4 className="font-semibold mb-2">Best suited for</h4>
        <div className="flex justify-between mb-6">
          <div className="text-center">
            {/* <User size={40} className="mx-auto mb-1 text-orange-500" /> */}
            Icon
            <span>Individual</span>
          </div>
          <div className="text-center">
            {/* <Users size={40} className="mx-auto mb-1 text-orange-500" /> */}
            Icon
            <span>Family</span>
          </div>
          <div className="text-center">
            {/* <Users size={40} className="mx-auto mb-1 text-orange-500" /> */}
            Icon
            <span>Multi Individual</span>
          </div>
        </div>
        <div className="flex space-x-4">
          <button className="bg-orange-500 text-white px-4 py-2 rounded">
            EXPLORE 3 PLANS
          </button>
          <button className="bg-orange-500 text-white px-4 py-2 rounded">
            QUICK QUOTE
          </button>
          <button className="border border-orange-500 text-orange-500 px-4 py-2 rounded">
            SEND ME AN EXPERT
          </button>
        </div>
      </div>
    </div>
  </div>
);
